/**
 * Query keys for DoseSpot eligibility / payer-coverage data.
 *
 * Mirrors :file:`entities/prior-auth/model/keys.ts` — scoped by patient user
 * id only since the eligibility list is whole-patient (not per-case).
 */
export const eligibilityKeys = {
  all: ['eligibility'] as const,

  patientList: (patientUserId: string) =>
    ['eligibility', 'patient', patientUserId, 'list'] as const,
};
